export default __webpack_public_path__ + "71fb5a1a6db978f431b130cbee87dc23.svg";